import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import APRmemo from "./APRComment.js/APRmemo";
import APRComment from "./APRComment.js/AprComments";
import axios from "../../api/axios";
import { formatDataGeneral, getAttributeValue } from "../../utils/utils";

function formatRemarks(rows) {
  const validRemarks = rows
    .map((row) => row.remarks?.trim())
    .filter((remark) => remark && remark.toUpperCase() !== "N/A");

  return validRemarks.join("; ");
}

// Register chart components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Annex8b = forwardRef(({ year, district, period, hideTableDis, assessmentStatus }, ref) => {

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    getData();
  }, [district, year, period]);

  useImperativeHandle(ref, () => ({
    getData: () => ({
      indicator: "Annex_8b",
      tableData
    }),
  }));

  function getData() {
    axios
      .get(`/tracker/trackedEntities?orgUnit=${district}&program=TX0gMnftQc8&startDate=${year}-01-01&endDate=${year}-12-31&pageSize=5000`)
      .then(result => {

        const data = result.data.instances;
        const items = formatDataGeneral(data, "Years", `${year}`) || [];
        const temp = [];

        items.forEach(val => {

          const dataSet = {
            item: getAttributeValue("Item Category", val),
            required: getAttributeValue("Required", val),
            actual: getAttributeValue("Actual", val),
            remarks: getAttributeValue("Remarks", val),
            year: getAttributeValue("Years", val),
          };

          temp.push(dataSet);
        });

        // console.log("temp logistic: ", temp)
        setTableData(temp);

        // const ORDER = [
        //   "Computer",
        //   "Printer",
        //   "Projector",
        //   "Office Space",
        //   "Vehicle"
        // ];

        // const formatedData =  formatAndSort(temp)

        // const formatAndSort = (data) => {
        //   return ORDER.map((itemName) => {
        //     const found = data.find((d) => d.item === itemName);

        //     return (
        //       found || {
        //         item: itemName,
        //         required: "0",
        //         actual: "0",
        //         remarks: "N/A",
        //         year: data[0]?.year || ""
        //       }
        //     );
        //   });
        // };


      })
      .catch(err => console.log(err))
  };

  const chartData = {
    labels: tableData.map((row) => row.item),
    datasets: [
      {
        label: "Required",
        data: tableData.map((row) => row.required),
        backgroundColor: "#007bff",
        borderColor: "#0056b3",
        borderWidth: 1,
      },
      {
        label: "Actual",
        data: tableData.map((row) => row.actual),
        backgroundColor: "#28a745",
        borderColor: "#1e7e34",
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: `Logistic Analysis, ${year}`,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 25,
        title: {
          display: true,
          text: "Number",
        },
      },
    },
  };

  return (
    <div className="col-12" style={{ width: '100%' }}>
      <h3>Update on key Logistics</h3>
      <div className="card" style={{ width: '100%' }}>
        <div className="card-header" ></div>
        <div className="card-body" style={{ width: '100%' }}>
          <APRmemo
            year={year}
            districtId={district}
            tableCommentedId={`Annex_8b-${year}`}
            hideTableDis={hideTableDis}
            assessmentStatus={assessmentStatus}
            period={period}
          />
          <div className="table-responsive" style={{ width: "100%" }}>
            <table
              className="table table-bordered"
              style={{
                width: "100%",
                borderCollapse: "collapse",
                tableLayout: "fixed",
              }}
            >
              <thead style={{ backgroundColor: "#d4edda", fontWeight: "bold" }}>
                <tr>
                  <th style={{ border: "1px solid #000", width: "8%" }} rowSpan="2"></th>
                  {["Computer", "Printer", "Projector", "Office Space", "Vehicle"].map((item) => (
                    <th key={item} style={{ border: "1px solid #000", textAlign: "center" }} colSpan="2">
                      {item}
                    </th>
                  ))}
                  <th style={{ border: "1px solid #000", width: "14%" }} rowSpan="2">Remarks</th>
                </tr>
                <tr>
                  {["Computer", "Printer", "Projector", "Office Space", "Vehicle"].flatMap((item) => [
                    <th key={`${item}-required`} style={{ border: "1px solid #000", textAlign: "center" }}>Required</th>,
                    <th key={`${item}-actual`} style={{ border: "1px solid #000", textAlign: "center" }}>Actual</th>,
                  ])}
                </tr>
              </thead>
              <tbody>
                <tr key={`${year}-table`}>
                  <td style={{ border: "1px solid #000" }}>RCC</td>

                  <td style={{ border: "1px solid #000", textAlign: "center" }}>{tableData.length > 0 ? tableData[0].required : 0}</td>
                  <td style={{ border: "1px solid #000", textAlign: "center" }}>{tableData.length > 0 ? tableData[0].actual : 0}</td>

                  <td style={{ border: "1px solid #000", textAlign: "center" }}>{tableData.length > 1 ? tableData[1].required : 0}</td>
                  <td style={{ border: "1px solid #000", textAlign: "center" }}>{tableData.length > 1 ? tableData[1].actual : 0}</td>

                  <td style={{ border: "1px solid #000", textAlign: "center" }}>{tableData.length > 2 ? tableData[2].required : 0}</td>
                  <td style={{ border: "1px solid #000", textAlign: "center" }}>{tableData.length > 2 ? tableData[2].actual : 0}</td>

                  <td style={{ border: "1px solid #000", textAlign: "center" }}>{tableData.length > 3 ? tableData[3].required : 0}</td>
                  <td style={{ border: "1px solid #000", textAlign: "center" }}>{tableData.length > 3 ? tableData[3].actual : 0}</td>

                  <td style={{ border: "1px solid #000", textAlign: "center" }}>{tableData.length > 4 ? tableData[4].required : 0}</td>
                  <td style={{ border: "1px solid #000", textAlign: "center" }}>{tableData.length > 4 ? tableData[4].actual : 0}</td>

                  <td style={{ border: "1px solid #000" }}>
                    {formatRemarks(tableData)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="mt-2">
            <small>
              Source: Fixed Asset Register & HR Department Report, {year}
            </small>
          </p>

          {/* Bar Chart */}
          <h4>Logistic Analysis, {year}</h4>
          <Bar data={chartData} options={chartOptions} />

          <APRComment
            data={tableData}
            year={year}
            districtId={district}
            tableCommentedId={`table20-${year}`}

          >
            {({ renderCommentInput, renderCommentList }) => (
              <>
                {renderCommentInput()}
                {renderCommentList()}
              </>
            )}
          </APRComment>
        </div>
      </div>
    </div>
  );
});

export default Annex8b;
